import React, { useEffect, useState } from 'react';
import LoadedSpaceList from '../../loaded/LoadedSpaceList';
import { getAllSpaces } from '../../services/MetadataService';
import useGlobal from '../../store';

const AllSpacesList = () => {
	const [spaces, setSpaces] = useState(null);
	const location = 'Spaces';
	let [currentState, currentActions] = useGlobal();

	useEffect(() => {
		async function fetchSpaces() {
		const data = await getAllSpaces();
		setSpaces(data);
		}
		fetchSpaces();
	}, []);

	useEffect(() => {
		if (currentState.currentModule !== location) {
		currentActions.setCurrentModule(location);
		}
	}, []);

	return (
		spaces && (
		<div className="layer3">
			<LoadedSpaceList spaces={spaces} />
		</div>
		)
	);
};

export default AllSpacesList;
